import { Link } from "react-router-dom";

const trendingTags = [
  { tag: "#StarBookPrime", count: "128K" },
  { tag: "#VerifiedFactory", count: "94K" },
  { tag: "#ShareAndEarn", count: "72K" },
  { tag: "#TikTokShop", count: "61K" },
  { tag: "#FamilyLife", count: "48K" },
  { tag: "#USAFactory", count: "39K" },
  { tag: "#EarnMore", count: "31K" },
];

const categories = [
  { icon: "ri-home-heart-line", label: "Life & Family", color: "text-pink-500" },
  { icon: "ri-shopping-bag-line", label: "Products", color: "text-orange-500" },
  { icon: "ri-money-dollar-circle-line", label: "Earnings", color: "text-green-500" },
  { icon: "ri-tiktok-line", label: "TikTok Shares", color: "text-gray-900" },
  { icon: "ri-youtube-line", label: "YouTube Reviews", color: "text-red-500" },
  { icon: "ri-instagram-line", label: "Instagram Posts", color: "text-pink-400" },
];

interface SocialLeftSidebarProps {
  onShareProduct: () => void;
}

export default function SocialLeftSidebar({ onShareProduct }: SocialLeftSidebarProps) {
  return (
    <aside className="hidden lg:block w-64 flex-shrink-0 space-y-4">
      {/* Profile Card */}
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <div className="h-16 w-full" style={{ background: "linear-gradient(135deg, #B8860B 0%, #FFD700 100%)" }} />
        <div className="px-4 pb-4 -mt-7">
          <div className="w-14 h-14 rounded-full bg-orange-100 flex items-center justify-center text-orange-400 text-2xl border-4 border-white mb-2">
            <i className="ri-user-line" />
          </div>
          <div className="font-bold text-gray-900 text-sm">Welcome!</div>
          <div className="text-xs text-gray-500 mb-3">Sign in to share your life & earn</div>
          <Link
            to="/auth"
            className="block w-full text-center py-2.5 bg-orange-500 text-white text-sm font-bold rounded-full hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            Sign In / Register
          </Link>
        </div>
      </div>

      {/* Share & Earn CTA */}
      <div
        className="rounded-2xl p-5 text-white relative overflow-hidden"
        style={{ background: "linear-gradient(135deg, #B8860B 0%, #DAA520 60%, #FFD700 100%)" }}
      >
        <div className="relative z-10">
          <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl mb-3">
            <i className="ri-money-dollar-circle-line text-white text-xl" />
          </div>
          <h3 className="font-extrabold text-sm mb-1 text-amber-950">Share & Earn Commission</h3>
          <p className="text-xs text-amber-900 mb-3 leading-relaxed">
            Share verified factory products to your YouTube, TikTok & Instagram fans. Earn real money for your family!
          </p>
          <button
            onClick={onShareProduct}
            className="w-full py-2 bg-amber-950 text-yellow-400 font-bold text-xs rounded-full hover:bg-amber-900 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-store-2-line mr-1" /> Pick a Product
          </button>
        </div>
      </div>

      {/* Browse Categories */}
      <div className="bg-white rounded-2xl border border-gray-100 p-4">
        <h3 className="font-bold text-gray-900 text-sm mb-3">Browse</h3>
        <div className="space-y-1">
          {categories.map((cat) => (
            <button
              key={cat.label}
              className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors cursor-pointer text-left"
            >
              <div className={`w-6 h-6 flex items-center justify-center ${cat.color}`}>
                <i className={cat.icon} />
              </div>
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      {/* Trending Tags */}
      <div className="bg-white rounded-2xl border border-gray-100 p-4">
        <h3 className="font-bold text-gray-900 text-sm mb-3">Trending Tags</h3>
        <div className="space-y-2">
          {trendingTags.map((item) => (
            <div key={item.tag} className="flex items-center justify-between py-1.5 border-b border-gray-50 last:border-0">
              <span className="text-sm text-orange-500 font-semibold cursor-pointer hover:text-orange-600">{item.tag}</span>
              <span className="text-xs text-gray-400">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}
